import React from 'react';
import { CadetWormhole } from '../Views/CadetWormhole';

export function NotFoundPage() {
  return <CadetWormhole imgUrl='/public/img/404-text.png' />;
}
